import { useHasPermission } from './useApiData';
import { useTenantFeatures } from './useTenantFeatures';
import { useRecruitmentFeature } from './useRecruitmentFeature';
import { usePayablesAccess } from './usePayablesAccess';
import { vendorEntryAccess, visibleVendorTabs } from 'src/components/shared/v2/presentation';

export function useVendorAccess() {
  const features = useTenantFeatures();
  const payables = usePayablesAccess();
  const recruitment = useRecruitmentFeature();
  const vendor = useHasPermission('vendor.read');
  const create = useHasPermission('vendor.create');
  const edit = useHasPermission('vendor.update');
  const read = useHasPermission('payables_vendor_admin.read');
  const agreements = useHasPermission('agreements.view');
  const manage = useHasPermission('agreements.manage');
  const approve = useHasPermission('agreements.approve');
  const hasPayables = features.enabledModules.includes('PAYABLES');
  const { portal, financial } = vendorEntryAccess({ modules: features.enabledModules, recruitmentEnabled: recruitment.enabled, recruitmentRead: vendor.hasPermission, payablesEnabled: payables.canRead, payablesRead: read.hasPermission });
  const canRead = !features.isConfigFailed && (financial || portal);
  return {
    isLoading: !features.isConfigLoaded || payables.isLoading || recruitment.isLoading || [vendor, create, edit, read, agreements, manage, approve].some((p) => p.isLoading),
    canRead, hasPayables, financial, portal,
    canManage: financial && payables.canManage,
    canVerify: financial && payables.canVerify,
    canCreate: financial ? payables.canManage : portal && create.hasPermission,
    canEditRecruitment: !financial && portal && edit.hasPermission,
    canReadAgreements: features.enabledModules.includes('AGREEMENTS') && agreements.hasPermission,
    canManageAgreements: manage.hasPermission,
    canApproveAgreements: approve.hasPermission,
    tabs: visibleVendorTabs({ modules: features.enabledModules, profile: canRead, portal, financial, banks: financial, documents: financial, bills: financial, agreements: agreements.hasPermission })
  };
}
